import React from "react";
import Card from "components/card";
import GuideSection from "./GuideSection";
import { Paragraph, List, SubTitle, TableText, KeyValue } from "variables/constants";

const renderContent = (item, index, theme) => {
    switch (item.type) {
        case "paragraph":
        return <Paragraph key={index} text={item.text} />;

        case "list":
            return <List key={index} text={item.text} items={item.items}/>;

        case "subsection":
            return (
                <div
                    key={index}
                    className={`pl-4 border-l-2 location-theme ${theme} border-section subTitle-color`}
                >
                    <SubTitle text={item.title}/>

                    {item.content.map((subItem, i) => renderContent(subItem, i))}
                </div>
            );

        case "tableText":
            return <TableText key={index} headers={item.headers} rows={item.rows} />;
        
        case "keyValue":
            return <KeyValue key={index} keyText={item.keyText} value={item.value} />;
        default:
            return null;
    }
};

const GuideCard = ({ section, theme }) => {
    return (
        <Card className="p-0">
            <GuideSection title={section.title} theme={theme}>
                {section.content.map((item, idx) => renderContent(item, idx, theme))}
            </GuideSection>
        </Card>
    );
};

export default GuideCard;
